import projection from '../generated/pwd502f1.json';
import { AcceptanceManifest } from '../types';

export const pwd502f1AcceptanceManifest = projection as AcceptanceManifest;
